export default {
  rewards: {
    title: "पुरस्कार",
    claim: "प्राप्त करें",
    weeklyCashback: "साप्ताहिक कैशबैक",
    weeklyCashbackDesc: "हर हफ्ते अपने साप्ताहिक नुकसान का एक हिस्सा वापस पाएं।",
    dailySpin: "दैनिक स्पिन",
    dailySpinDesc: "बड़े पुरस्कार जीतने के मौके के लिए हर दिन पहिया घुमाएं।",
    invitationBonus: "आमंत्रण बोनस",
    invitationBonusDesc: "दोस्तों को आमंत्रित करें और हर जुड़ने वाले पर पुरस्कार पाएं।",
    rebate: "रिबेट",
    rebateDesc: "हर दांव पर रिबेट कमाएं, जीत हो या हार।",
    bannerTitle: "पुरस्कार",
    bannerSubtitle: "कार्य पूरे करें और शानदार पुरस्कार पाएं!",
    sectionTitle: "आपके शानदार पुरस्कार",
    goNow: "अभी जाएं",
    historyReceived: "कुल प्राप्त",
    todayReceived: "आज प्राप्त",
    cashbackDialog: {
      title: "बेट कैशबैक",
      loading: "लोड हो रहा है...",
      empty: "कोई कैशबैक नियम नहीं",
      level: "स्तर",
      amountRange: "राशि सीमा",
      rewardRate: "इनाम दर",
      rewardCap: "इनाम सीमा",
    },
    cards: {
      checkin: {
        title: "दैनिक चेक-इन",
        subtitle: "रोज़ चेक-इन के लिए लॉगिन करें",
        description: "खिलाड़ी, हर दिन चेक-इन करना न भूलें~",
      },
      cashback: {
        title: "कैशबैक",
        subtitle: "प्लेटफ़ॉर्म रिबेट पुरस्कार",
      },
      rescue: {
        title: "बचाव बोनस",
        subtitle: "3 कैश गेम खेलें",
        description: "दिवालिया खिलाड़ियों के लिए बचाव कोष",
      },
      task: {
        title: "कार्य",
        subtitle: "प्लेटफ़ॉर्म कार्य पूरे करें",
        description: "प्लेटफ़ॉर्म कार्य",
      },
      balance: {
        title: "तिजोरी",
        subtitle: "दैनिक ब्याज कमाएं",
        description: "प्लेटफ़ॉर्म तिजोरी",
      },
      loan: {
        title: "ऋण बोनस",
        subtitle: "आसानी से उधार लें",
        description: "प्लेटफ़ॉर्म उधार",
      },
    },
    checkIn: {
      dailySignIn: "दैनिक चेक-इन",
      totalRewards: "कुल पुरस्कार",
      headlineDaysBefore: "",
      headlineDaysAfter: "दिनों तक चेक-इन करें,",
      headlineTailCumulative: "एक दिन छूटने से कोई फर्क नहीं पड़ता।",
      headlineTailDate: "एक दिन छूटने पर उस दिन का पुरस्कार खो जाता है।",
      headlineCumulative: "{days} दिनों तक चेक-इन करें बड़ा जीतने के लिए, एक दिन छूटने से कोई फर्क नहीं पड़ता।",
      headlineDate: "{days} दिनों तक चेक-इन करें, एक दिन छूटने पर उस दिन का पुरस्कार खो जाता है।",
      headlineEmpty: "पुरस्कार जीतने के लिए चेक-इन करें",
      title: "चेक-इन",
      modeCumulative: "संचयी चेक-इन",
      modeDate: "तिथि चेक-इन",
      rewards: "पुरस्कार",
      signedIn: "चेक-इन हो चुका",
      day: "दिन {n}",
      loading: "लोड हो रहा है...",
      empty: "कोई सक्रिय चेक-इन गतिविधि नहीं।",
      btnCheckIn: "चेक-इन",
      btnSigned: "हो गया",
      btnLocked: "लॉक",
      claimSuccess: "चेक-इन सफल, पुरस्कार {amount} {currency} जमा हुआ",
      claimFailed: "चेक-इन विफल",
      alreadySigned: "आप आज पहले ही चेक-इन कर चुके हैं",
      notLogin: "कृपया पहले लॉगिन करें",
    },
  },
};
